module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation/print-allotmentletter/print-allotmentletter.component.css
// module id = ./src/app/allocation/print-allotmentletter/print-allotmentletter.component.css
// module chunks = main